<template>
   <table class="players table w-full">
    <thead>
        <tr>
            <td></td>
            <td></td>
            <td></td>
        </tr>
    </thead>
    <tbody>
        <tr v-for="p in players">
            <td class="w-6">{{ p.jersey_number }}</td>
            <td><Link :href="route('mbbplayer', {slug: p.slug})">{{p.first_name }} {{ p.last_name }}</Link></td>
            <td>{{ p.position }}</td>
            <td>{{ p.heightInInches }}</td>
        </tr>
    </tbody>
   </table>
</template>

<script>
import { Link } from '@inertiajs/vue3';
export default {
   name: "MBBPlayers",
   props: ['players'],
   components: { Link },
   computed: {},
   data() {
       return {

       }
   },
   mounted() {

   },
   methods: {

   }
}
</script>
<style>
.players tbody tr td {
    padding: 4px;
}
.players tbody tr:nth-child(even) {
    @apply bg-slate-400/50;
}
</style>
